import CodePanes from './CodePanes'

// Body for a code (Library) grid window. Renders the viewer|comments split once
// the selected item is resolved (from the workspace's item cache), a loading
// placeholder while its standard rehydrates on reload, or a prompt when the
// window has nothing selected yet.
function CodeWindowBody({
  item,
  items,
  windowId,
  loading,
  panes,
  onPanesChange,
  onRevealInNav,
  history,
  historyIndex,
  recall,
  onVisit,
  onHistory,
}) {
  if (item) {
    return (
      <CodePanes
        item={item}
        items={items}
        windowId={windowId}
        panes={panes}
        onPanesChange={onPanesChange}
        onRevealInNav={onRevealInNav}
        history={history}
        historyIndex={historyIndex}
        recall={recall}
        onVisit={onVisit}
        onHistory={onHistory}
      />
    )
  }
  if (loading) {
    return <div className="display-empty">Loading…</div>
  }
  return <div className="display-empty">Select an item from the list.</div>
}

export default CodeWindowBody
